import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  cancelVideoZipRequestPolling,
  resetVideoZipRequestState,
} from 'redux/modules/video-zip-request';
import { Dispatch } from 'redux/types';
import { OnReprocessClip } from './types';

export type UseReprocessClipConfig = {
  onReprocessClip: OnReprocessClip;
};

export type UseReprocessClipResult = {
  onReprocessClip: OnReprocessClip;
};

export default function useReprocessClip({
  onReprocessClip,
}: UseReprocessClipConfig): UseReprocessClipResult {
  const dispatch = useDispatch<Dispatch>();

  const handleReprocessClip: OnReprocessClip = useCallback(
    (clipId, options) => {
      dispatch(cancelVideoZipRequestPolling());
      dispatch(resetVideoZipRequestState());

      return onReprocessClip(clipId, options);
    },
    [dispatch, onReprocessClip],
  );

  return {
    onReprocessClip: handleReprocessClip,
  };
}
